import * as React from "react";
import { graphql } from "gatsby";
import styled from "styled-components";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import PageContainer from "../pageContainer";

export const fragment = graphql`
  fragment TextContent on ContentfulPageSectionText {
    textContent {
      raw
    }
    internal {
      type
    }
  }
`;

const Container = styled.div`
  max-width: 700px;
  margin: 5rem auto;

  p {
    margin-top: 1rem;
  }
`;

const Text = ({ data }) => {
  return (
    <PageContainer as={"section"}>
      <Container>{renderRichText(data.textContent)}</Container>
    </PageContainer>
  );
};
export const textName = "ContentfulPageSectionText";

export default Text;
